import { render, staticRenderFns } from "./home-page2.vue?vue&type=template&id=086abee0&scoped=true&"
import script from "./home-page2.vue?vue&type=script&lang=js&"
export * from "./home-page2.vue?vue&type=script&lang=js&"
import style0 from "./home-page2.vue?vue&type=style&index=0&id=086abee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086abee0",
  null
  
)

export default component.exports